import axios from "axios";

const API_URL = "https://github-api.sistemasinteegra.com.br/portal";

export const createPortal = async (data) => {
  try {
    const response = await axios.post(API_URL, data);
    return response.data;
  } catch (error) {
    console.error("Erro ao criar portal:", error);
    throw (
      error.response?.data?.message ||
      error.message ||
      "Erro desconhecido ao criar portal"
    );
  }
};
